import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

/** Confirmations homogènes (français, bouton de danger rouge, annulation neutre) */
@Injectable({ providedIn: 'root' })
export class ConfirmService {

  async danger(titre: string, texte = '', confirmer = 'Supprimer'): Promise<boolean> {
    const r = await Swal.fire({
      title: titre, text: texte, icon: 'warning', showCancelButton: true, focusCancel: true,
      confirmButtonText: confirmer, cancelButtonText: 'Annuler',
      confirmButtonColor: '#dc2626', cancelButtonColor: '#6b7280', reverseButtons: true
    });
    return !!r.isConfirmed;
  }

  async question(titre: string, texte = '', confirmer = 'Confirmer'): Promise<boolean> {
    const r = await Swal.fire({
      title: titre, html: texte, icon: 'question', showCancelButton: true,
      confirmButtonText: confirmer, cancelButtonText: 'Annuler',
      confirmButtonColor: '#0d631b', cancelButtonColor: '#6b7280', reverseButtons: true
    });
    return !!r.isConfirmed;
  }

  /** Demande un motif (annulation tracée). Renvoie null si abandon, '' si aucun motif saisi. */
  async motif(titre: string, texte = '', confirmer = 'Annuler l\'opération', obligatoire = false, valeurInitiale = ''): Promise<string | null> {
    const r = await Swal.fire({
      title: titre, text: texte, icon: 'warning', input: 'text', inputValue: valeurInitiale,
      inputLabel: obligatoire ? 'Motif' : 'Motif (facultatif)', inputPlaceholder: 'Ex. : saisie en double, erreur de montant…',
      showCancelButton: true, confirmButtonText: confirmer, cancelButtonText: 'Retour',
      confirmButtonColor: '#dc2626', cancelButtonColor: '#6b7280', reverseButtons: true,
      inputValidator: v => obligatoire && !v?.trim() ? 'Indiquez un motif' : null
    });
    return r.isConfirmed ? (r.value || '').trim() : null;
  }
}
